import { useCallback } from "react";
import { ChatCardPropsType } from "./ChatCard";
const RenderFollowupQuestions = ({
    followupQuestions // onFollowupQuestionClicked,
}: ChatCardPropsType) => {
    let timeoutId: any;
    return (
        <div>
            {Array.isArray(followupQuestions) ? (
                <ol className=" pl-8">
                    {followupQuestions.length ? <div className=" text-black font-bold">Follow up Questions:</div> : ""}
                    {followupQuestions.map((item, index) => (
                        <div className="" key={index}>
                            <div className="mt-2 text-left">
                                <div className="p-2 rounded-md bg-gray-300 ">
                                    <span className=" p-2 rounded-md">{item.toString().replace(/_/g, " ")}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </ol>
            ) : typeof followupQuestions === "string" ? (
                <p>{followupQuestions}</p>
            ) : (
                followupQuestions && ""
            )}
        </div>
    );
};

export default RenderFollowupQuestions;
